import { defineComponent as t, openBlock as a, createBlock as n, unref as l, mergeProps as h, withCtx as p, createElementVNode as c } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const d = /* @__PURE__ */ t({
  name: "IconTrophy",
  __name: "IconTrophy",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const r = o;
    return (v, e) => (a(), n(l(m), h(r, { "view-box": "0 0 24 24" }), {
      default: p(() => [...e[0] || (e[0] = [
        c("path", {
          "fill-rule": "evenodd",
          d: "M7.5 2.75A1.25 1.25 0 0 0 6.25 4v.75H4.61a1.25 1.25 0 0 0-1.226 1.495L3.943 9.04a2.75 2.75 0 0 0 2.697 2.21h.477a8.5 8.5 0 0 0 .708 1.472c.868 1.413 2.061 2.247 3.425 2.468v1.56H8.5A1.25 1.25 0 0 0 7.25 18v1.75H7a.75.75 0 0 0 0 1.5h10a.75.75 0 0 0 0-1.5h-.25V18a1.25 1.25 0 0 0-1.25-1.25h-2.75v-1.56c1.364-.221 2.557-1.055 3.424-2.468a8.5 8.5 0 0 0 .709-1.472h.067a3.25 3.25 0 0 0 3.187-2.613l.479-2.392A1.25 1.25 0 0 0 19.39 4.75h-1.64V4a1.25 1.25 0 0 0-1.25-1.25h-9m-.826 7C6.441 8.725 6.3 7.559 6.261 6.25H4.915l.499 2.495A1.25 1.25 0 0 0 6.64 9.75h.034M7.75 5.502c0 3.031.549 5.125 1.353 6.436.787 1.28 1.81 1.812 2.897 1.812s2.11-.532 2.896-1.812c.805-1.311 1.354-3.406 1.354-6.438V4.25h-8.5v1.252m10.916 2.841a1.75 1.75 0 0 1-1.33 1.364C17.562 8.693 17.7 7.54 17.738 6.25h1.346l-.419 2.093M15.25 18.25v1.5h-6.5v-1.5h6.5",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  d as default
};
